import React from 'react';
import AnalyticsCard from '../../../components/Analytics/AnalyticsCard/AnalyticsCard';
import ConversationsResponse from '../../../types/Analytics/ConversationsResponse';

interface AnalyticsCardsContainerProps {
  currentData?: ConversationsResponse;
  prevData?: ConversationsResponse;
  isLoading: boolean;
}

function AnalyticsCardsContainer({
  currentData,
  prevData,
  isLoading
}: Readonly<AnalyticsCardsContainerProps>): React.ReactElement {
  const prevTotalMessages = prevData?.totalMessages ?? 0;
  const prevTotalConversations = prevData?.totalConversations ?? 0;
  const prevAvgMessagesPerConversation =
    prevData?.avgMessagesPerConversation ?? 0;
  const prevAvgConversationDurationMins =
    prevData?.avgConversationDurationMins ?? 0;
  const prevAvgDailyConversations = prevData?.avgDailyConversations ?? 0;

  const currentTotalMessages = currentData?.totalMessages ?? 0;
  const currentTotalConversations = currentData?.totalConversations ?? 0;
  const currentAvgMessagesPerConversation =
    currentData?.avgMessagesPerConversation ?? 0;
  const currentAvgConversationDurationMins =
    currentData?.avgConversationDurationMins ?? 0;
  const currentAvgDailyConversations = currentData?.avgDailyConversations ?? 0;

  return (
    <div className='grid w-full grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-5'>
      <AnalyticsCard
        isLoading={isLoading}
        title='Total messages'
        tooltipText='The total number of messages sent in the selected period'
        content={
          <div className='p-3 text-[2.5em] font-semibold'>
            {currentTotalMessages}
          </div>
        }
        prevValue={prevTotalMessages}
        currentValue={currentTotalMessages}
        style={{ height: 175 }}
      />
      <AnalyticsCard
        isLoading={isLoading}
        title='Total conversations'
        tooltipText='The total conversations that took place in the selected period'
        content={
          <div className='p-3 text-[2.5em] font-semibold'>
            {currentTotalConversations}
          </div>
        }
        prevValue={prevTotalConversations}
        currentValue={currentTotalConversations}
        style={{ height: 175 }}
      />
      <AnalyticsCard
        isLoading={isLoading}
        title='Avg. messages per conversation'
        tooltipText='Average number of messages sent per conversation in the selected period'
        content={
          <div className='p-3 text-[2.5em] font-semibold'>
            {currentAvgMessagesPerConversation}
          </div>
        }
        prevValue={prevAvgMessagesPerConversation}
        currentValue={currentAvgMessagesPerConversation}
        style={{ height: 175 }}
      />
      <AnalyticsCard
        isLoading={isLoading}
        title='Avg. minutes per conversation'
        tooltipText='Average duration of conversations in minutes in the selected period'
        content={
          <div className='p-3 text-[2.5em] font-semibold'>
            {currentAvgConversationDurationMins}
          </div>
        }
        prevValue={prevAvgConversationDurationMins}
        currentValue={currentAvgConversationDurationMins}
        style={{ height: 175 }}
      />
      <AnalyticsCard
        isLoading={isLoading}
        title='Avg. daily conversations'
        tooltipText='Average number of conversations per day in the selected period'
        content={
          <div className='p-3 text-[2.5em] font-semibold'>
            {currentAvgDailyConversations}
          </div>
        }
        prevValue={prevAvgDailyConversations}
        currentValue={currentAvgDailyConversations}
        style={{ height: 175 }}
      />
    </div>
  );
}

export default AnalyticsCardsContainer;
